import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Container, Row, Col, Card, CardBody, Form, FormGroup, Label, Input, Button, Alert } from "reactstrap";
import ApiClass from "../apiManager/apiClass";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "./LoginPage.css";

const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const apiClass = ApiClass.getInstance();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await apiClass.loginWeb(email, password);
      const code = res?.responseCode;
      const data = res?.responseData;

      if (code === 200 && data?.msg) {
        const token = data.msg;
        localStorage.setItem("hosting-noodle-token", token);
        apiClass.setCreds(token);
        navigate("/dashboard");
        window.location.reload();
      } else {
        setError(data?.msg || "Login failed. Please try again.");
      }
    } catch (err) {
      const msg = err?.message || err?.msg || "Invalid email or password. Please try again.";
      setError(typeof msg === "string" ? msg : "Login failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Navbar />
      <div className="hn-login-page">
        <Container className="py-5">
          <Row className="justify-content-center">
            <Col md="6" lg="5">
              <Card className="hn-login-card">
                <CardBody className="p-4">
                  <h2 className="hn-login-title text-center mb-4">
                    <i className="fas fa-bowl-food me-2" aria-hidden="true" />
                    Hosting Noodle
                  </h2>
                  <p className="text-center text-muted mb-4">Sign in to your account</p>
                  {error && (
                    <Alert color="danger" className="small">
                      {error}
                    </Alert>
                  )}
                  <Form onSubmit={handleSubmit}>
                    <FormGroup>
                      <Label for="email">Email</Label>
                      <Input
                        id="email"
                        type="email"
                        placeholder="you@example.com"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        autoComplete="email"
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label for="password">Password</Label>
                      <Input
                        id="password"
                        type="password"
                        placeholder="••••••••"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        autoComplete="current-password"
                      />
                    </FormGroup>
                    <Button color="warning" block className="hn-login-btn mt-3" disabled={loading}>
                      {loading ? "Signing in…" : "Log in"}
                    </Button>
                  </Form>
                  <p className="text-center mt-3 small text-muted">
                    <Link to="/">Back to Home</Link>
                  </p>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <Footer />
    </>
  );
};

export default LoginPage;
